<script setup lang="ts">
import { isValidString } from "@/Utils/String";

export interface TcNotificationProps {
  title: string;
  detail: string;
  type?: string;
}

defineProps<TcNotificationProps>();
</script>

<template>
  <div class="tc_notification">
    <p class="tc_notification_title">{{ title }}</p>
    <p class="tc_notification_detail" v-if="isValidString(detail)">{{ detail }}</p>
  </div>
</template>

<style lang="scss">
.tc_notification {
  @include sp.padding(false, 4);
  @include colors.bg(semantic, error);

  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 74px;
  width: 100%;
  z-index: 2;

  &_title {
    @include text.general(high, s);
    @include colors.color(content, inverse);
  }
  &_detail {
    @include text.general(low, m);
    @include colors.color(content, inverse);
  }
}
</style>
